import {
  ONLY_NUMBERS_MASK,
  ONLY_NUMBERS_WITH_DECIMALS_MASK,
  PHONE_MASK,
  SLUG_MASK,
  EMPTY_MASK,
  NO_LEADING_ZERO_MASK,
} from 'commons/constants';
import replaceValue from './replace-value';
import { replaceValueWithCondition, replaceValueConditions } from './replace-value-with-condition';
import type { Mask } from './String.types';

const { GREATER_THAN } = replaceValueConditions;

const replaceValueMask = (regex: RegExp, replaceWith?: string): Mask => ({
  maskFunction: replaceValue,
  regex,
  replaceWith,
});

const replaceValueWithConditionMask = (
  condition: string,
  compareWith: string,
  replaceWith?: string,
): Mask => ({
  maskFunction: replaceValueWithCondition,
  condition,
  compareWith,
  replaceWith,
});

export const replaceOnlyNumbersMask = replaceValueMask(ONLY_NUMBERS_MASK);
export const replaceOnlyNumbersWithDecimalsMask = replaceValueMask(ONLY_NUMBERS_WITH_DECIMALS_MASK);
export const replacePhoneMask = replaceValueMask(PHONE_MASK);
export const replaceSlugMask = replaceValueMask(SLUG_MASK);
export const replaceDefaultToZeroMask = replaceValueMask(EMPTY_MASK, '0');
export const replaceDefaultToOneMask = replaceValueMask(EMPTY_MASK, '1');
export const replaceNoLeadingZeroMask = replaceValueMask(NO_LEADING_ZERO_MASK);
export const replaceMax100000000Mask = replaceValueWithConditionMask(
  GREATER_THAN,
  '100000000',
  '100000000',
);
export const replaceMax99Mask = replaceValueWithConditionMask(GREATER_THAN, '99', '99');
export const replaceMax30Mask = replaceValueWithConditionMask(GREATER_THAN, '30', '30');
